export default __webpack_public_path__ + "static/media/slide2.2a2294a5.jpg";